import React from 'react';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { catalogBibShape } from '@bibliocommons/bc-prop-types';

import { selectUgcSummary } from 'app/selectors/bibs/UgcSelector';
import { selectCatalogBib } from 'app/selectors/catalogBibs/CatalogBibSelector';
import ContentNotices from './ContentNotices';

export function ContentNoticesContainer(props) {
  return <ContentNotices {...props} />;
}

ContentNoticesContainer.propTypes = {
  catalogBib: catalogBibShape.isRequired,
  summary: ImmutablePropTypes.map.isRequired
};

const mapStateToProps = state => ({
  catalogBib: selectCatalogBib(state),
  summary: selectUgcSummary(state)
});

export default connect(mapStateToProps)(ContentNoticesContainer);
